import SvgIcon from "./IconStars.svg?react";

export const IconStars = SvgIcon;
